import { createClient as baseCreateClient, type ClientConfig } from '@prismicio/client'
import prismicConfig from '../prismic.config.json'

export const createClient = (config: ClientConfig = {}) => {
	return baseCreateClient(prismicConfig.repositoryName, {
		routes: prismicConfig.routes,
		...config
	})
}
